import { render, staticRenderFns } from "./wpList.vue?vue&type=template&id=8bd290c8&scoped=true"
import script from "./wpList.vue?vue&type=script&lang=js"
export * from "./wpList.vue?vue&type=script&lang=js"
import style0 from "./wpList.vue?vue&type=style&index=0&id=8bd290c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd290c8",
  null
  
)

export default component.exports